import { Hex } from 'viem';
import { environment } from '../../environments/environment';
import { ZERO_ADDRESS } from '../types/constants';
import { Address as AddressValues } from '../generated/address';

// Web workers are bundled by a nested esbuild call that drops plugins, so fileReplacements never
// reach them and `environment` is always the testnet default there — the network rides a define.
declare const ngMunchNetwork: 'mainnet' | 'testnet' | undefined;
const network = typeof ngMunchNetwork === 'undefined' ? environment.network : ngMunchNetwork;

export const Address = network === 'mainnet' ? AddressValues.MAINNET : AddressValues.TESTNET;

const CPU_ADDRESSES: ReadonlySet<string> = new Set<string>(
  [
    Address.CPU
  ].filter((a) => a !== ZERO_ADDRESS),
);

export function isCpuAddress(addr: Hex | undefined | null): boolean {
  if (!addr) return false;
  return CPU_ADDRESSES.has(addr.toLowerCase());
}

export type Difficulty = 'easy' | 'medium' | 'hard' | 'extra-hard';

// Reported to belch as the CPU team slot for a Random CPU battle (no numbered team). The numbered
// teams report their 0-based index. Must match RANDOM_CPU_TEAM_SLOT in belch's cpuTeamStatsRepository.
export const RANDOM_CPU_TEAM_SLOT = -1;

const CPU_LABELS: Record<Difficulty, string> = {
  easy: 'Easy CPU',
  medium: 'Medium CPU',
  hard: 'Hard CPU',
  'extra-hard': 'Hell CPU',
};

export function cpuDifficultyLabel(difficulty: Difficulty): string {
  return CPU_LABELS[difficulty];
}

// Opponent name for a CPU battle: the difficulty tier, or generic "CPU" when it's unknown (legacy
// replay rows). Callers pick the source — a replay's recorded difficulty, or the live chosen one.
export function cpuOpponentLabel(difficulty: Difficulty | null | undefined): string {
  return difficulty ? cpuDifficultyLabel(difficulty) : 'CPU';
}

// Derived from CPU_LABELS so a new tier can't silently fall through validation (persist/replay).
export function isDifficulty(value: unknown): value is Difficulty {
  return typeof value === 'string' && value in CPU_LABELS;
}